import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

export default function DisplayCaption({ text }) {
  return (
    <figcaption>
      <div className="liveblog-card__leadmedia-caption">
        {parse(DOMPurify.sanitize(text))}
      </div>
    </figcaption>
  );
}

DisplayCaption.propTypes = {
  text: PropTypes.string.isRequired,
};
